import {Injectable} from '@angular/core';
import {ApiService} from './api.service';


@Injectable()
export class NotificationsService {

  constructor(private apiService: ApiService) {
  }

  getNotifications() {
    return this.apiService.get('/notifications');
  }

  getNotPayInsurance() {
    return this.apiService.get('/notpayinsurance');
  }

  getAppStatistics() {
    return this.apiService.get('/statistics/app');
  }

}
